import { IconButton as ThemeUiIconButton } from "theme-ui"
import * as styles from "./styles"
import React from "react"

export interface IconButtonProps {
  ariaLabel?: string
  children: React.ReactNode
  className?: string
  onClick?: (event: MouseEvent<HTMLButtonElement, MouseEvent>) => void
  variant?: IconButtonVariants
}

export type IconButtonVariants = "primary"

export const IconButton: React.FC<IconButtonProps> = ({
  ariaLabel,
  children,
  className,
  onClick,
  variant = "primary",
}) => {
  const [isKeyboardFocused, setIsKeyboardFocused] = React.useState<boolean>(
    true
  )

  return (
    <ThemeUiIconButton
      className={className}
      onMouseDown={() => setIsKeyboardFocused(false)}
      onKeyDown={() => setIsKeyboardFocused(true)}
      aria-label={ariaLabel}
      onClick={onClick}
      variant={`icon.${variant}`}
      sx={{
        ...styles.root,
        ...(isKeyboardFocused
          ? {
              "&:focus": {
                boxShadow: "outline",
                borderRadius: "full",
              },
            }
          : {}),
      }}
    >
      {children}
    </ThemeUiIconButton>
  )
}
